import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-4 animate-slide-up">
      <div className="glass-effect rounded-xl p-6 max-w-4xl mx-auto shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="bg-accent-gold/20 p-3 rounded-full flex-shrink-0">
            <FaCookie className="text-2xl text-accent-gold" />
          </div>
          
          <div className="flex-1">
            <h3 className="text-xl font-bold mb-2">Cookie Preferences</h3>
            <p className="text-dark-muted mb-4">
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies. You can manage your preferences at any time.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <button
                onClick={handleAccept}
                className="px-6 py-2 bg-gradient-to-r from-accent-primary to-accent-secondary hover:opacity-90 rounded-lg font-semibold transition-opacity"
              >
                Accept All
              </button>
              <button
                onClick={handleDecline}
                className="px-6 py-2 bg-dark-card hover:bg-dark-border border border-dark-border rounded-lg transition-colors"
              >
                Decline
              </button>
              <a
                href="/cookies"
                className="px-6 py-2 text-dark-muted hover:text-dark-text transition-colors"
              >
                Learn More
              </a>
            </div>
          </div>
          
          <button
            onClick={handleDecline}
            className="text-dark-muted hover:text-dark-text transition-colors flex-shrink-0"
            aria-label="Close"
          >
            <FaTimes className="text-xl" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

